import _ from "lodash";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getAssignUserReq,
  getProviderReportReq,
  getProviderReportResClear,
  getTeamMatesReq,
  getTeamMatesResClear,
  setCurrentView,
} from "../../redux/assignCourse/actions";
import { setCurrentFilterView } from "../../redux/reports/actions";
import { SessionKeys } from "../../utils/AppUtils";
import StaticUtils from "../../utils/StaticUtils";
import Select from 'react-select'
import { useTranslation } from "react-i18next";

const ChooseProvider = (props) => {

  const {
    selectedProviderList, setSelectedProviderList,
    parentId, parentName,
    isMobile
  } = props;

  const dispatch = useDispatch();
  const { courseId } = useParams();
  const {t} = useTranslation()
  const providerSearchRes = useSelector(
    (state) => state.assignCourse.providerReportList
  );
  const assignedUserRes = useSelector(
    (state) => state.assignCourse.assignedUsers
  );
  const [searchInput, setSearchInput] = useState("");
  const [providerList, setProviderList] = useState([]);
  const [selectedCount, setSelectedCount] = useState(0);
  const [assignedUsers, setAssignedUsers] = useState([]);
  const [errorMsg, setErrorMsg] = useState('');
  const [providerOptList, setProviderOptList] = useState([])
  const [defaultValue, setDefaultValue] = useState([]);

  useEffect(() => {
    dispatch(getProviderReportResClear());
    searchProvider()
  }, []);

  useEffect(() => {
    setSelectedCount(selectedProviderList?.length);
    const newDefaultValue = selectedProviderList.map((provider) => ({
      value: provider.p_id,
      label: provider.p_name
          }));
      
          setDefaultValue(newDefaultValue);
  }, [selectedProviderList]);

  useEffect(() => {
    if (searchInput !== undefined && searchInput.length > 2)
      searchProvider();
    else setErrorMsg("");
  }, [searchInput]);

  const searchProvider = () => {
    dispatch(
      getProviderReportReq({
        module: "chooseProvider",
        postData: {
          token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          search: searchInput,
        },
      })
    );
  };



  useEffect(() => {
    // console.log("providerSearchRes: ", providerSearchRes);
    if (!_.isEmpty(providerSearchRes)) {
      if (providerSearchRes?.status === "success") {
        const providerArr = providerSearchRes?.payload?.payload;
        setProviderList(providerArr);
        setProviderOptList(_.map(providerArr, (provider) => {
					return {
						value: provider.p_id,
						label: provider.p_name
					}
				}))
        if (!_.isEmpty(searchInput) && searchInput?.length > 2 && providerSearchRes?.payload?.payload?.length === 0) {
          setErrorMsg(t("No result found for your search."));
        } else {
          setErrorMsg("");
        }
      }
    } else {
      setProviderOptList([]);
      setErrorMsg("");
    }
  }, [providerSearchRes]);




  const selectItem = (index) => {
    let tempArr = _.cloneDeep(providerList);
    let selectedTempArray = _.cloneDeep(selectedProviderList);
    if (!StaticUtils.isContainObject(selectedTempArray, tempArr[index], 2)) {
      selectedTempArray.push(tempArr[index]);
    }

    setSelectedProviderList(selectedTempArray);
    tempArr.splice(index, 1);
    setProviderList(tempArr);
  };

  const removeItem = (index) => {
    let selectedTempArray = _.cloneDeep(selectedProviderList);
    let tempArr = _.cloneDeep(providerList);

    if (!StaticUtils.isContainObject(tempArr, selectedTempArray[index], 2)) {
      tempArr.push(selectedTempArray[index]);
    }

    setProviderList(tempArr);
    selectedTempArray.splice(index, 1);
    setSelectedProviderList(selectedTempArray);
  };

  return (
    <>
      <div className="chooseteamate">
        <h4>{t("Choose Provider")}</h4>
        <div className="input-lear position-relative d-flex">
          <label for="teamsearch" className="input__label">
            {t("Search")}
          </label>
          {/* <input
            type="text"
            id="teamsearch"
            name="teamsearch"
            className="input_searchfield_search-cart "
            placeholder="Start searching"
            onChange={(evt) => {
              setSearchInput(evt.target.value);
            }}
          /> */}
          <Select 
							isMulti
							name="colors"
							className="basic-multi-select w-100 multi-label-select"
    						classNamePrefix="xsel"
							options={providerOptList}
              value={defaultValue}
							onChange={(e) => {
								console.log(e)
								// setSelectedOffice(e)
								if (!_.isEmpty(e)) {
									setErrorMsg('')
									let data = [];
									for (let provider of providerList) {
										for (let sO of e) {
											if (sO.value === provider.p_id) {
												data.push(provider)
											}
										}
									}
									setSelectedProviderList(data)
								} else {
									setSelectedProviderList([])
									// setErrorMsg("Please select at lease one provider.");
								}
							}}
						/>
        </div>
        <p className="error-msg">{errorMsg}</p>
        {/* <div className="search-team-result">
          {providerList?.map((item, index) => {
            return (
              <div className="team-result-box">
                <div className="team-user-img">
                  <img
                    src={
                      item?.p_logo !== ""
                        ? item?.p_logo
                        : "/images/avatar.svg"
                    }
                    alt="user"
                  />
                </div>
                <div className="userteamname">{item?.p_name}</div>
                <div
                  className="addteammate cursor-pointer"
                  onClick={() => {
                    selectItem(index);
                  }}
                >
                  +
                </div>
              </div>
            );
          })}
        </div>
        <div className="teamselected">
          <div className="selectresilt">
            Selected Provider<strong>({selectedCount})</strong>
          </div>
          <div className="search-team-result slectedteammates">
            {selectedProviderList?.map((item, index) => {
              return (
                <div className="team-result-box">
                  <div className="team-user-img">
                    <img
                      src={
                        item?.p_logo !== ""
                          ? item?.p_logo
                          : "/images/avatar.svg"
                      }
                      alt="user"
                    />
                  </div>
                  <div className="userteamname">{item?.p_name}</div>
                  <div
                    className="addteammate cursor-pointer"
                    onClick={() => {
                      //   console.log("removeItem");
                      removeItem(index);
                    }}
                  >
                    +
                  </div>
                </div>
              );
            })}
          </div>
        </div> */}



        {false&&<div className="buttonsteammate">
          {false && <button
            type="button"
            className="btn btn-primary btn-block back-button"
            onClick={() => {
              dispatch(setCurrentFilterView(1));
            }}
          >
            Back
          </button>}
          
            <button
              type="button"
              className="btn btn-primary btn-block setup-button"
              onClick={() => {
                setSelectedProviderList(selectedProviderList)
                // dispatch(setCurrentFilterView(1));
              }}
            >
              Apply
            </button>
          
        </div>}




      </div>
    </>
  );
};

export default ChooseProvider;
